import React from 'react'
import { Space, Typography } from '@surecompanies/core_components'
import { getDataTypeDisplayName } from '../constants'
import styles from '../ReviewPlanSnapshot.module.scss'

const { Text } = Typography

interface PlanSnapshotInfoProps {
  dataType: string
  total: number
}

function PlanSnapshotInfo({ dataType, total }: PlanSnapshotInfoProps) {
  const displayName = getDataTypeDisplayName(dataType)

  return (
    <Space direction="vertical" size="small">
      <Text strong className={styles.title}>
        {displayName}{' '}
        <span className={styles.recordCount}>
          ({(total ?? 0).toLocaleString()} Records)
        </span>
      </Text>
    </Space>
  )
}

export default PlanSnapshotInfo
